"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgVolumeUpOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M1 10v12h6.71L17 27.8V4.2L7.71 10zm2 2h4v8H3zm12 12.2l-6-3.75v-8.9l6-3.75zM21 11.05A7 7 0 0121 21l1.41 1.41a9 9 0 000-12.72z" }),
        React.createElement("path", { d: "M26.6 5.4l-1.41 1.41a13 13 0 010 18.38l1.41 1.41a15 15 0 000-21.2z" })));
}
exports.default = SvgVolumeUpOutline;
//# sourceMappingURL=VolumeUpOutline.js.map